<template>
    <div>
        <UploadsTable>
            <template>
                <UploadFile v-if="userPermissions.includes('uploadFile')" />
            </template>
        </UploadsTable>
    </div>
</template>

<script>
import UploadsTable from '../../../components/servorgs/uploads/uploadsList/UploadsTable';
import UploadFile from '../../../components/servorgs/uploads/uploadsList/UploadFile';
import { mapState } from 'vuex';

export default {
    components: {
        UploadsTable,
        UploadFile
    },
    computed: {
        ...mapState('permissions', ['userPermissions']),
        previewDataFilter: {
            get() {
                return this.$store.state.uploads.uploadsListFilter;
            },
            set(val) {
                this.$store.commit('uploads/setUploadsListFilter', val);
            }
        }
    },
    async mounted() {},
    methods: {},
    async beforeRouteLeave(to, from, next) {
        if (to.name !== 'UploadsDetail') {
            this.previewDataFilter = {};
            this.$store.commit('uploads/setFilter', null);
            next();
        } else {
            next();
        }
    }
};
</script>

<style></style>
